import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {Scenario} from '../message/Scenario';
import {ScenarioCriteria} from './ScenarioCriteria';
import {ScenarioScenario} from './ScenarioScenario';

export class ScenarioWrapper extends BaseWrapper<Scenario, ScenarioCriteria, ScenarioScenario>  {}

